import React, { useEffect, useState } from 'react';
import HeaderSafe from '../../components/HeaderSafe';
import { useLocation } from "react-router-dom";
import img1 from '../../image/car.svg'
import Button from 'react-bootstrap/Button';
import { Link, animateScroll as scroll } from "react-scroll";
import extraordinario from '../../image/extraordinario_icon.png';
import biologico from '../../image/biologico_icon.png';
import quimico from '../../image/quimico_icon.png';
import pgrs from '../../image/pgrs_icon.png';
import patter1 from '../../image/patterSolucao1.svg';
import patter2 from '../../image/patterSolucao2.svg';
import patter3 from '../../image/pattern3.svg';
import vector1 from '../../image/Vector.png';
import extraordinario1 from '../../image/extraordinario1.png';
import biologico1 from '../../image/biologico1.png';
import quimico1 from '../../image/quimico1.png';
import pgrs1 from '../../image/pgrs.png';
import footer from '../../image/footerSolucoes.png';
import './style.css'
import Header from '../../components/Header';
import arrowUp from '../../image/arrowUp.svg';
import arrowDown from '../../image/arrowDown.svg';
import Pgrss from './components/Pgrss';
import Biologico from './components/Biologico';
import { atendimetoWhatsapp, logNavegacao } from '../../function';
import Extraordinario from './components/Extraordinario';
import Quimico from './components/Quimico';

function Solucoes({history}) {
    const location = useLocation();
    let user = null;
    let visible = false;
    if(!location.state){
        console.log(location.state)
    }else{
        user = location.state.user;
        visible = true;
    }
    const scrollToTop = () => {
        scroll.scrollToTop(); 
    };
    let [loja, setLoja] = useState('https://play.google.com/store/apps/details?id=com.grupourbam.app')
    useEffect(() => {
        scrollToTop();
        getMobileOperatingSystem()
    }, [])
    function getMobileOperatingSystem() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
        // // Windows Phone must come first because its UA also contains "Android"
        // if (/windows phone/i.test(userAgent)) {
        //     return "Windows Phone";
        // }
    
        // if (/android/i.test(userAgent)) {
            
        //     return "Android";
        // }
    
        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            setLoja('https://apps.apple.com/br/app/grupo-urbam/id1627088091');
            // return "iOS";
        }
    }
    const newAttendance = async (msg) => {
        atendimetoWhatsapp(msg);
        logNavegacao('Atendimento', 'msg');
    }
    const open = (url) => {
        window.open(url, '_blank', 'noreferrer');
    }
    return (
        <>
            {visible ? <Header history={history} user={user} /> : <HeaderSafe history={history} user={user} />}
            <div style={{ height: 134, width: "100%"}}></div>
            <div className="over" id='conteiner'>
                <div className="row bodySolucoes" style={{width: "100%"}}  id="top">
                    <div className='col-12 col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6' 
                        style={{
                            display: "flex",
                            justifyContent: 'center',
                            alignItems: 'center',
                            position: 'relative'
                        }}>
                        <img
                        src={img1}
                        alt="Imagem Carro"
                        style={{width: "50%"}}
                        />
                    </div>
                    <div className='col-12 col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6'
                        style={{
                            display: "flex",
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                            flexDirection: 'column'
                        }}>
                        <div className="row" style={{
                            display: "flex",
                            alignItems: 'center',
                            padding: 40
                        }}>
                            <p 
                            className='titleConheca'>
                                Conheça todas as possibilidades do 
                                Grupo Urbam.
                            </p>
                            <p 
                            className='subTitleConheca'>
                                Uma empresa, diversas soluções. 
                            </p>
                            <div id="btConheca">
                                <Link
                                    activeClass="active"
                                    to="solucoes"
                                    spy={true}
                                    smooth={true}
                                    offset={0}
                                    duration={500}
                                    containerId="conteiner"
                                    >
                                        <Button style={{
                                            boxShadow: "0px 15.3171px 15.3171px rgba(0, 0, 0, 0.25)",
                                        }} 
                                        variant="secondary"
                                        >
                                            SOLUÇÕES URBAM
                                        </Button>
                                </Link>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div 
                    className="bodySolucoes2" 
                    style={{ 
                        backgroundColor: 'var(--main-secondy)', 
                        width: "100%",
                        margin: 0, 
                        overflowY: "auto", 
                        overflowX: 'hidden',
                        display: "flex",
                        flexDirection: 'column',
                        alignContent: 'center',
                        justifyContent: 'center'
                    }} 
                    id="solucoes">
                    <img
                    src={patter1}
                    alt="patter1"
                    className='patter'
                    />
                    <img
                    src={patter2}
                    alt="patter2"
                    className='patter'
                    />
                    <div
                    style={{
                        display: "flex",
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <p 
                        style={{
                            color: "var(--main-white-color)", 
                            fontSize: 34, 
                            fontWeight: 700,
                            marginBottom: 30
                        }}>
                            SOLUÇÕES URBAM
                        </p>
                    </div>
                    <div className="row" style={{paddingLeft: 20, paddingRight: 20}}>
                        <div className='col-12 col-sm-12 col-xs-6 col-md-6 col-lg-6 col-xl-3' 
                        style={{
                            display: "flex",
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginBottom: 20
                        }}>
                            <div className="w-96 bg-white rounded-tl-3xl rounded-br-3xl cards">
                                <div className='cardShadow px-8 py-12 rounded-tl-3xl rounded-br-3xl'> 
                                    <p 
                                    style={{
                                        color: "var(--main-bg-color)", 
                                        fontSize: 24, 
                                        fontWeight: 700,
                                        height: '20%', 
                                    }}>
                                        <span style={{fontSize: 16}}>COLETA DE </span>
                                        RESÍDUO EXTRAORDINÁRIO
                                    </p>
                                    <div style={{
                                        display: 'flex', 
                                        width: '100%',
                                        height: '60%', 
                                        justifyContent: "center",
                                        alignItems: 'center', 
                                        flexDirection: 'column', 
                                        }}>
                                        <img
                                            src={extraordinario}
                                            alt="Imagem extraordinario"
                                            style={{height: 150, width: 150, marginBottom: 30}}
                                            />
                                        
                                    </div>
                                    <div style={{
                                        display: 'flex', 
                                        width: '100%',
                                        height: '20%', 
                                        justifyContent: "center",
                                        alignItems: 'center', 
                                        flexDirection: 'column', 
                                        }}>
                                            <Link
                                                activeClass="active"
                                                to="extraordinario"
                                                spy={true}
                                                smooth={true}
                                                offset={0}
                                                duration={500}
                                                className="buttonAbsolut"
                                                containerId="conteiner"
                                                >
                                                <Button className='btSaiba' 
                                                variant="secondary"
                                                >
                                                SABER MAIS
                                                </Button>
                                            </Link>
                                            </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-sm-12 col-xs-6 col-md-6 col-lg-6 col-xl-3' 
                            style={{
                                display: "flex",
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginBottom: 20
                            }}>
                           <div className="w-96 bg-teal-500 rounded-tl-3xl rounded-br-3xl cards">
                                <div className='cardShadow px-8 py-12 rounded-tl-3xl rounded-br-3xl'>
                                    <p 
                                    style={{
                                        color: "var(--main-white-color)", 
                                        fontSize: 24, 
                                        fontWeight: 700,
                                        height: '20%', 
                                    }}>
                                        <span style={{fontSize: 16}}>COLETA DE </span><br></br>
                                        RESÍDUO BIOLÓGICO <br></br>
                                        <span style={{fontSize: 16}}> E PERFURO CORTANTE</span>
                                    </p>
                                    <div style={{
                                        display: 'flex', 
                                        width: '100%',
                                        alignItems: 'center', 
                                        flexDirection: 'column', 
                                        height: '60%', 
                                        justifyContent: "center",
                                        }}>
                                        <img
                                        src={biologico}
                                        alt="Imagem biologico"
                                        style={{height: 150, width: 150}}
                                        />
                                    </div>
                                    <div style={{
                                        display: 'flex', 
                                        width: '100%',
                                        height: '20%', 
                                        justifyContent: "center",
                                        alignItems: 'center', 
                                        flexDirection: 'column', 
                                        }}>
                                        <Link
                                            activeClass="active"
                                            to="biologico"
                                            spy={true}
                                            smooth={true}
                                            offset={0}
                                            duration={500}
                                            className="buttonAbsolut"
                                            containerId="conteiner"
                                            >
                                            <Button className='btSaiba' 
                                            variant="secondary"
                                            >
                                            SABER MAIS
                                            </Button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-sm-12 col-xs-6 col-md-6 col-lg-6 col-xl-3' 
                        style={{
                            display: "flex",
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginBottom: 20
                        }}>
                            <div className="w-96 bg-white rounded-tl-3xl rounded-br-3xl cards">
                                <div className='cardShadow px-8 py-12 rounded-tl-3xl rounded-br-3xl'>
                                    <p 
                                    style={{
                                        color: "var(--main-bg-color)", 
                                        fontSize: 24, 
                                        fontWeight: 700,
                                        height: '20%', 
                                    }}>
                                        <span style={{fontSize: 16}}>COLETA DE </span><br></br>
                                        RESÍDUO QUÍMICO
                                    </p>
                                    <div style={{
                                        display: 'flex', 
                                        width: '100%',
                                        alignItems: 'center', 
                                        flexDirection: 'column', 
                                        height: '60%', 
                                        justifyContent: "center",
                                        }}>
                                        <img
                                        src={quimico}
                                        alt="Imagem quimico"
                                        style={{height: 150, width: 150, marginBottom: 30}}
                                        />
                                    </div>
                                    <div style={{
                                        display: 'flex', 
                                        width: '100%',
                                        height: '20%', 
                                        justifyContent: "center",
                                        alignItems: 'center', 
                                        flexDirection: 'column', 
                                        }}>
                                        <Link
                                            activeClass="active"
                                            to="quimico"
                                            spy={true}
                                            smooth={true}
                                            offset={0}
                                            duration={500}
                                            className="buttonAbsolut"
                                            containerId="conteiner"
                                            >
                                            <Button className='btSaiba' 
                                            variant="secondary"
                                            >
                                                SABER MAIS
                                            </Button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-sm-12 col-xs-6 col-md-6 col-lg-6 col-xl-3' 
                        style={{
                            display: "flex",
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginBottom: 20
                        }}>
                            <div className="w-96 bg-teal-500 rounded-tl-3xl rounded-br-3xl cards">
                                <div className='cardShadow px-8 py-12 rounded-tl-3xl rounded-br-3xl'>
                                    <p 
                                    style={{
                                        color: "var(--main-white-color)", 
                                        fontSize: 24, 
                                        fontWeight: 700,
                                        height: '20%', 
                                    }}>
                                        <span style={{fontSize: 16}}>Consultoria </span><br></br>
                                        PGRS/PGRSS
                                    </p>
                                    <div style={{
                                        display: 'flex', 
                                        width: '100%',
                                        alignItems: 'center', 
                                        flexDirection: 'column', 
                                        height: '60%', 
                                        justifyContent: "center",
                                        }}>
                                        <img
                                        src={pgrs}
                                        alt="Imagem pgrss"
                                        style={{height: 150, width: 150, marginBottom: 30}}
                                        />
                                    </div>
                                    <div style={{
                                        display: 'flex', 
                                        width: '100%',
                                        height: '20%', 
                                        justifyContent: "center",
                                        alignItems: 'center', 
                                        flexDirection: 'column', 
                                        }}>
                                        <Link
                                            activeClass="active"
                                            to="pgrss"
                                            spy={true}
                                            smooth={true}
                                            offset={0}
                                            duration={500}
                                            className="buttonAbsolut"
                                            containerId="conteiner"
                                            >
                                            <Button className='btSaiba' 
                                            variant="secondary"
                                            >
                                                SABER MAIS
                                            </Button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Extraordinario patter3={patter3} extraordinario1={extraordinario1} newAttendance={newAttendance} arrowUp={arrowUp} arrowDown={arrowDown}/>
                <Biologico vector1={vector1} newAttendance={newAttendance} biologico1={biologico1} arrowUp={arrowUp} arrowDown={arrowDown} />
                <Quimico patter3={patter3} quimico1={quimico1} newAttendance={newAttendance} arrowUp={arrowUp} arrowDown={arrowDown}/>
                <Pgrss vector1={vector1} newAttendance={newAttendance} pgrs1={pgrs1} arrowUp={arrowUp} arrowDown={arrowDown} />
                <div id="app" style={{width: "100%", cursor: 'pointer'}} onClick={()=>open(loja)}>
                    <img
                        src={footer}
                        alt="Aplicativo"
                        style={{width: '100%'}}
                    />
                    <div  style={{backgroundColor: 'var(--main-white-color)', width: "100%", margin: 0, overflowY: "hidden", overflowX: 'hidden'}}>
                        <div style={{color: "var(--main-font)", width: "100%", height: 30, textAlign: 'center', fontWeight: 400, fontSize: 16}}>
                            Copyright © Todos os direitos reservados - 2023
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Solucoes;